import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1280;

function getIsBelowBreakpoint(breakpoint: number) {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < breakpoint;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(() => getIsBelowBreakpoint(MOBILE_BREAKPOINT));

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(getIsBelowBreakpoint(MOBILE_BREAKPOINT));
    };
    mql.addEventListener('change', onChange);
    setIsMobile(getIsBelowBreakpoint(MOBILE_BREAKPOINT));
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

export function useIsMobileOrTablet() {
  const [isMobileOrTablet, setIsMobileOrTablet] = React.useState(() =>
    getIsBelowBreakpoint(DESKTOP_BREAKPOINT),
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${DESKTOP_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobileOrTablet(getIsBelowBreakpoint(DESKTOP_BREAKPOINT));
    };
    mql.addEventListener('change', onChange);
    setIsMobileOrTablet(getIsBelowBreakpoint(DESKTOP_BREAKPOINT));
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobileOrTablet;
}
